export const formatNumber = (inputValue: string): string => {
  const isNumber = /^[0-9,]*$/.test(inputValue);

  if (isNumber) {
    const withoutCommas = inputValue.replaceAll(",", "");
    return withoutCommas.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return inputValue;
};

export const toNumber = (inputValue: string): string => {
  const isNumber = /^[0-9,]*$/.test(inputValue);

  if (isNumber) {
    return inputValue.replaceAll(",", "");
  }

  return inputValue;
};

export const formatNumberWithoutDot = (inputValue: string): string => {
  const theNumber = inputValue.replace(/[^\d.]/g, ""); // keep only digits and dots
  const beforeDot = theNumber.split(".")[0]; // get parts before the dot

  return beforeDot.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // add comma before each 3 digits
};
